enum EventType {
  ACFU_APPOINTMENT_BOOKED = 'ACFU - Appointment Booked',
  ACFU_EXTENDED_WINDOW_REASON_PROVIDED = 'ACFU - Extended Window Reason Provided',
  ACFU_MORE_DATES_CLICKED = 'ACFU - More Dates Clicked',
  APPOINTMENT_CANCELLATION_FORM_SUBMISSION_FAILED = 'Appointment Cancellation Form Submission Failed',
  APPOINTMENT_RESCHEDULE_FORM_SUBMISSION_FAILED = 'Appointment Reschedule Form Submission Failed',
  APPOINTMENT_RESCHEDULE_FORM_SUBMISSION_FAILED_SLOT_UNAVAILABLE = 'Appointment Reschedule Form Submission Failed - Slot Unavailable',
  APPOINTMENT_CANCELLATION_FORM_SUBMISSION_SUCCEEDED = 'Appointment Cancellation Form Submission Succeeded',
  APPOINTMENT_COMPLETE_NEW_APPOINTMENT_LINK_CLICK = 'Appointment Complete New Appointment Link Click',
  APPOINTMENT_FORM_MISSING_DATA = 'Appointment Form Missing Data',
  APPOINTMENT_FORM_MISSING_PARAMETERS = 'Appointment Form Missing Parameters',
  APPOINTMENT_FORM_SUBMISSION_FAILED = 'Appointment Form Submission Failed',
  APPOINTMENT_FORM_SUBMISSION_FAILED_SLOT_UNAVAILABLE = 'Appointment Form Submission Failed - Slot Unavailable',
  APPOINTMENT_FORM_SUBMISSION_SUCCEEDED = 'Appointment Form Submission Succeeded',
  APPOINTMENT_FORM_VIEWED = 'Appointment Form Viewed',
  APPOINTMENT_RESCHEDULE_FORM_VIEWED = 'Appointment Reschedule Form Viewed',
  APPOINTMENT_SERVICE_TIME_LOADING_AVAILABILITIES = 'Time Spent Loading Availabilities From Appointment Service',
  AVAILABILITY_CONSTRAINT_CREATED = 'Availability Constraint - Created',
  AVAILABILITY_CONSTRAINT_DELETED = 'Availability Constraint - Deleted',
  AVAILABILITY_CONSTRAINT_UPDATED = 'Availability Constraint - Updated',
  AVAILABILITY_CONSTRAINT_VIEWED = 'Availability Constraint - Viewed',
  ERROR_INVALID_COUNTRY = 'Error - Invalid country',
  ERROR_NO_COUNTRY = 'Error - No country',
  IN_TRIAL_AFTERCARE_FOLLOW_UP_OPTION_DISABLED = 'In Trial - Aftercare Follow-up Option Disabled',
  IN_TRIAL_AFTERCARE_FOLLOW_UP_SUBSTITUTION_APPLIED = 'In Trial - Aftercare Follow-up Substitution Applied',
  IN_TRIAL_AFTERCARE_FOLLOW_UP_VALIDATION_FALLBACK = 'In Trial - Aftercare Follow-up Validation Fallback',
  INTERMEDIATE_APPOINTMENT_TYPE_SELECTION_PAGE_BUTTON_CLICKED = 'Intermediate Appointment Type Selection Page Button Clicked',
  MANUAL_TIME_BUTTON_CLICKED = 'Manual Time Button Clicked',
  MANUAL_TIME_BUTTON_DISPLAYED = 'Manual Time Button Displayed',
  OUT_OF_TRIAL_FOLLOW_UP_OPTION_DISABLED = 'Out Of Trial - Follow-up Option Disabled',
  OUT_OF_TRIAL_HEARING_AID_EVALUATION_OPTION_DISABLED = 'Out Of Trial - Hearing Aid Evaluation Option Disabled',
  OUT_OF_TRIAL_HEARING_AID_EVALUATION_SUBSTITUTION_APPLIED = 'Out Of Trial - Hearing Aid Evaluation Substitution Applied',
  OUT_OF_TRIAL_FOLLOW_UP_SUBSTITUTION_APPLIED = 'Out Of Trial - Follow-up Substitution Applied',
  OUT_OF_TRIAL_FOLLOW_UP_VALIDATION_FALLBACK = 'Out Of Trial - Follow-up Validation Fallback',
  PROVIDER_RECOMMENDATION_SERVICE_TIME_LOADING_RECOMMENDATIONS = 'Time Spent Loading Recommendations From Provider Recommendation Service',
  RESERVATION_CANCELLATION_SUBMISSION_FAILED = 'Reservation Cancellation Submission Failed',
  RESERVATION_CANCELLATION_SUBMISSION_SUCCEEDED = 'Reservation Cancellation Submission Succeeded',
  RESERVATION_CONVERSION_SUBMISSION_FAILED = 'Reservation Conversion To Appointment Submission Failed',
  RESERVATION_CONVERSION_SUBMISSION_FAILED_SLOT_UNAVAILABLE = 'Reservation Conversion To Appointment Submission Failed - Slot Unavailable',
  RESERVATION_CONVERSION_SUBMISSION_SUCCEEDED = 'Reservation Conversion To Appointment Submission Succeeded',
  RESERVATION_FORM_SUBMISSION_FAILED = 'Reservation Form Submission Failed',
  RESERVATION_FORM_SUBMISSION_FAILED_SLOT_UNAVAILABLE = 'Reservation Form Submission Failed - Slot Unavailable',
  RESERVATION_FORM_SUBMISSION_SUCCEEDED = 'Reservation Form Submission Succeeded',
  RESERVATION_PAGE_MISSING_PARAMETERS = 'Reservation Page Missing Parameters',
  SHOP_CALENDAR_PAGE_VIEWED = 'Shop Calendar - Page Viewed',
  SHOP_CALENDAR_RESOURCE_SELECTED = 'Shop Calendar - Resource Changed',
  UNAVAILABILITY_CONSTRAINT_CREATED = 'Unavailability Constraint - Created',
  UNAVAILABILITY_CONSTRAINT_DELETED = 'Unavailability Constraint - Deleted',
  UNAVAILABILITY_CONSTRAINT_UPDATED = 'Unavailability Constraint - Updated',
  TOAST = 'Toast',
}

export { EventType }
